<template>
  <div class="loading-button">
    <slot name="left"></slot>
    <v-btn
      v-if="isUsingOtherBtn"
      outline
      :large="isBigBtn"
      :disabled="otherBtnDisabled"
      class="UXbtn loading-btn other-btn"
      @click="otherBtnEvent"
    >
      {{ otherBtnText }}
    </v-btn>
    <v-btn
      dark
      color="#ff8c8c"
      :large="isBigBtn"
      :loading="isLoading"
      :disabled="disabled || defaultBtnDisabled"
      class="UXbtn loading-btn"
      @click="defaultBtnEvent"
    >
      {{ defaultBtnText }}
      <div slot="loader" class="loading-slot">
        <div class="loading-progress-box">
          <v-progress-circular indeterminate :size="14" :width="2"></v-progress-circular>
        </div>
        <div class="loading-text-box">
          <span class="loading-save-text">
            {{ loadingBtnText }}
          </span>
        </div>
      </div>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'loadingButton',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    defaultBtnText: {
      type: String,
      default: '保存',
      required: false
    },
    loadingBtnText: {
      type: String,
      default: '保存中',
      required: false
    },
    isUsingOtherBtn: {
      type: Boolean,
      default: false,
      required: false
    },
    otherBtnText: {
      type: String,
      default: 'キャンセル',
      required: false
    },
    defaultBtnEvent: {
      type: Function,
      default: () => {},
      required: false
    },
    otherBtnEvent: {
      type: Function,
      default: () => {},
      required: false
    },
    isSmallBtn: {
      type: Boolean,
      default: false,
      required: false
    },
    isBigBtn: {
      type: Boolean,
      default: false,
      required: false
    },
    otherBtnDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    defaultBtnDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      require: false
    }
  }
}
</script>

<style lang="scss">
.loading-button {
  display: flex;
  justify-content: center;
  .loading-btn {
    &.other-btn {
      margin-right: 10px;
    }

    .loading-slot {
      display:flex;
      .loading-progress-box {
        width:20px;
        margin-right:2px;
      }
      .loading-text-box {
        .loading-save-text {
          font-size: 12px;
          font-weight: 700;
        }
      }
    }
  }

  .loading-btn.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
    opacity: 0.3;
    background-color: #ff8c8c !important;
  }

  .loading-btn.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
    color: #ff8c8c !important;
    border: 1px solid #ff8c8c !important;
    background-color: transparent !important;
    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loadingButton.vue